import { render, staticRenderFns } from "./ClipInfo.vue?vue&type=template&id=5f4eb8c2&scoped=true"
import script from "./ClipInfo.vue?vue&type=script&lang=js"
export * from "./ClipInfo.vue?vue&type=script&lang=js"
import style0 from "./ClipInfo.vue?vue&type=style&index=0&id=5f4eb8c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4eb8c2",
  null
  
)

export default component.exports